import { Link } from "react-router-dom";

/**
 * Bloq logo — uses the official PNG wordmark uploaded by the user.
 * `white` toggles between the dark-on-light and the white-on-dark version.
 * `size` controls the height in pixels (width auto-scales from the 1200×500 source).
 * `withWord` is kept for API parity but ignored — the PNG already includes the wordmark.
 */
const BLACK_LOGO =
  "https://customer-assets.emergentagent.com/job_bloq-operate/artifacts/mey68qbc_Bloq%20Logo%20Black%20NB%201200x500.png";
const WHITE_LOGO =
  "https://customer-assets.emergentagent.com/job_bloq-operate/artifacts/h058vg8w_Bloq%20Logo%20White%20NB%201200x500.png";

export default function BloqLogo({ size = 26, white = false, withWord = true, asLink = true }) {
  // The PNG aspect ratio is 1200:500 (= 2.4). We derive the width from the requested height.
  const height = size;
  const width = Math.round(size * 2.4);
  const src = white ? WHITE_LOGO : BLACK_LOGO;

  const img = (
    <img
      src={src}
      alt="Bloq"
      width={width}
      height={height}
      style={{ height, width, objectFit: "contain", display: "block" }}
      draggable={false}
    />
  );

  if (!asLink) return <span data-testid="bloq-logo">{img}</span>;
  return (
    <Link to="/" data-testid="bloq-logo" className="inline-flex items-center select-none" style={{ textDecoration: "none" }}>
      {img}
    </Link>
  );
}
